import { Injectable } from "@angular/core";
import { UtilityService } from "@irb-common/services/utility.service";
import { IPortfolioResultResponse, IPortfolioResultLotRebalanceSummary, IPortfolioResultSECRebal } from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";

@Injectable({
  providedIn: "root",
})
export class PrOrdersCacheService {
  constructor(private util: UtilityService) {}

  // NOT IN USE
  // saveSellOrderDetails(item: IPortfolioResultLotRebalanceSummary) {
  //   console.log(item);
  //   /*const parentId = this.util.getObjectValue(item, "parentId");
  //
  //   if (parentId) {
  //     const secItem;
  //     ppsdOrderStore.fetchItemByIdentity({
  //       identity: parentId,
  //       onItem(item) {
  //         secItem = item;
  //       },
  //     });
  //
  //     this.cachePpsdOrderItemDetails(secItem, item, ppsdOrderGrid); //#82093
  //   } else if (mayHaveChildren) {
  //     this.cachePpsdOrderItemDetails(item, null, ppsdOrderGrid);
  //   }*/
  // }
  //
  // cachePpsdOrderItemDetails(secItem: IPortfolioResultSECRebal, lotItem: IPortfolioResultLotRebalanceSummary) {
  //   console.log(secItem, lotItem);
  //   /*const ppsdOrderStore = ppsdOrderGrid.store;
  //   this.store = new dojo.data.ItemFileWriteStore({ data: { identifier: "id", items: [] } });
  //
  //   this.store.newItem(this.createPpsdOrderCachedItem(ppsdOrderStore, secItem, null, null, true));
  //
  //   if (lotItem) {
  //     //const txnType = tempStore.currTxnType;
  //     //const txnAmt = tempStore.currTxnAmt;
  //     const txnType = lotItem.txnType[0];
  //     const txnAmt = lotItem.txnAmt[0];
  //     const selectedLotId = this.util.getObjectValue(lotItem, "rowId");
  //
  //     this.store.newItem(this.createPpsdOrderCachedItem(ppsdOrderStore, lotItem, txnType, txnAmt, false));
  //
  //     ppsdOrderGrid.treeModel.getChildren(secItem, function (childItems) {
  //       for (const i in childItems) {
  //         const childItem = childItems[i];
  //         const lotId = this.util.getObjectValue(childItem, "rowId");
  //         if (lotId != selectedLotId) {
  //           this.store.newItem(this.createPpsdOrderCachedItem(ppsdOrderStore, childItem, null, null, false));
  //         }
  //       }
  //     });
  //   } else {
  //     ppsdOrderGrid.treeModel.getChildren(secItem, function (childItems) {
  //       for (const i in childItems) {
  //         this.store.newItem(this.createPpsdOrderCachedItem(ppsdOrderStore, childItems[i], null, null, false));
  //       }
  //     });
  //   }*/
  // }

  createPpsdOrderCachedItem(item: IPortfolioResultLotRebalanceSummary, txnType: string, txnAmt: number, isParent: boolean) {
    const cachedItem: any = {};
    cachedItem.id = this.util.getObjectValue(item, "rowId");
    cachedItem.sellTerm = this.util.getObjectValue(item, "sellTerm");
    cachedItem.penaltyAmt = this.util.getObjectValue(item, "penaltyAmt");
    cachedItem.parentSellAll = this.util.getObjectValue(item, "parentSellAll");
    cachedItem.isParent = isParent;
    cachedItem.txnShares = this.util.getObjectValue(item, "txnShares");
    cachedItem.afterRebalMktVal = this.util.getObjectValue(item, "afterRebalMktVal");
    cachedItem.afterRebalShares = this.util.getObjectValue(item, "afterRebalShares");

    if (txnType != null) {
      cachedItem.txnType = txnType;
    } else {
      cachedItem.txnType = this.util.getObjectValue(item, "txnType");
    }

    if (txnAmt != null) {
      cachedItem.txnAmt = txnAmt;
    } else {
      cachedItem.txnAmt = this.util.getObjectValue(item, "txnAmt");
    }

    return cachedItem;
  }

  restoreSellOrderDetails(data: IPortfolioResultResponse) {
    false && console.log(data);
  }

  // NOT IN USE
  // resetLotOrderItem(item: IPortfolioResultLotRebalanceSummary, cachedItem: IPortfolioResultLotRebalanceSummary) {
  //   const txnType = this.util.getObjectValue(cachedItem, "txnType");
  //   const txnAmt = this.util.getObjectValue(cachedItem, "txnAmt");
  //   const txnShares = this.util.getObjectValue(cachedItem, "txnShares");
  //   const sellTerm = this.util.getObjectValue(cachedItem, "sellTerm");
  //   const parentSellAll = this.util.getObjectValue(cachedItem, "parentSellAll");
  //   const afterRebalMktVal = this.util.getObjectValue(cachedItem, "afterRebalMktVal");
  //   const afterRebalShares = this.util.getObjectValue(cachedItem, "afterRebalShares");
  //
  //   this.util.setObjectValue(item, "txnType", txnType);
  //   this.util.setObjectValue(item, "txnAmt", txnAmt);
  //   this.util.setObjectValue(item, "txnShares", txnShares);
  //   this.util.setObjectValue(item, "sellTerm", sellTerm);
  //   this.util.setObjectValue(item, "parentSellAll", parentSellAll);
  //   this.util.setObjectValue(item, "afterRebalMktVal", afterRebalMktVal);
  //   this.util.setObjectValue(item, "afterRebalShares", afterRebalShares);
  // }
  //
  // resetSecOrderItem(item: IPortfolioResultLotRebalanceSummary, cachedItem: IPortfolioResultLotRebalanceSummary) {
  //   const txnType = this.util.getObjectValue(cachedItem, "txnType");
  //   const txnAmt = this.util.getObjectValue(cachedItem, "txnAmt");
  //   const txnShares = this.util.getObjectValue(cachedItem, "txnShares");
  //   const sellTerm = this.util.getObjectValue(cachedItem, "sellTerm");
  //   const penaltyAmt = this.util.getObjectValue(cachedItem, "penaltyAmt");
  //   const afterRebalMktVal = this.util.getObjectValue(cachedItem, "afterRebalMktVal");
  //   const afterRebalShares = this.util.getObjectValue(cachedItem, "afterRebalShares");
  //
  //   this.util.setObjectValue(item, "txnType", txnType);
  //   this.util.setObjectValue(item, "txnAmt", txnAmt);
  //   this.util.setObjectValue(item, "txnShares", txnShares);
  //   this.util.setObjectValue(item, "sellTerm", sellTerm);
  //   this.util.setObjectValue(item, "penaltyAmt", penaltyAmt);
  //   this.util.setObjectValue(item, "afterRebalMktVal", afterRebalMktVal);
  //   this.util.setObjectValue(item, "afterRebalShares", afterRebalShares);
  // }
}
